var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { mapResponseToJson, mapResponseToText } from '@atlassiansox/asc-core';
import { fetch } from 'cross-fetch';
export class BXPExpressClient {
    constructor({ baseUrl = BXPExpressClient.DEFAULT_BASE_URL } = {}) {
        this.baseUrl = baseUrl;
    }
    getXsrfToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToText(yield fetch(`${this.baseUrl}/auth/xsrf`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    accept: 'text/plain'
                }
            }));
        });
    }
    cloudSignupAnonymous({ payload, cookies }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/cloud/signupAnon`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-Cookies': JSON.stringify(cookies)
                },
                body: JSON.stringify(payload),
                credentials: 'include'
            }));
        });
    }
    marketplaceAppInstall({ siteName, appKey, xsrfToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/marketplace/app/install`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'xsrf-token': xsrfToken
                },
                body: JSON.stringify({ siteName, appKey }),
                credentials: 'include'
            }));
        });
    }
    cloudExpandFreeValidation({ cloudId, productKeys, edition }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/cloud/expand-free-validation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    cloudId,
                    productKeys,
                    edition
                })
            }));
        });
    }
    postBreachStatus({ payload }) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                headers: {
                    'content-type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(payload)
            };
            return mapResponseToJson(yield fetch(`${this.baseUrl}/cloud/expand-free-validation`, options));
        });
    }
    productEditionByCloudId({ cloudId, productKey }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/cloud/edition/${cloudId}/${productKey}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            }));
        });
    }
}
BXPExpressClient.DEFAULT_BASE_URL = 'https://wac.stg.internal.atlassian.com/endpoint';
//# sourceMappingURL=bxp-express-client.js.map